module.exports = __webpack_public_path__ + "static/media/logo_soundcloud.c700cf5f.svg";